export class MaCantineConnectionDTO {
  clientId: string;
  isConnected: boolean;
  maCantineUri: string;
}
